import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const BrandingContext = createContext({
  organization_name: "ISCIC Trust",
  logo_url: "/brand/iscic-logo.jpg",
  favicon_url: "/brand/iscic-logo.jpg",
  refresh: () => {},
});

function applyFavicon(url) {
  if (!url || typeof document === "undefined") return;
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = url;
}

export function BrandingProvider({ children }) {
  const [brand, setBrand] = useState({
    organization_name: "ISCIC Trust",
    logo_url: "/brand/iscic-logo.jpg",
    favicon_url: "/brand/iscic-logo.jpg",
  });

  const refresh = async () => {
    try {
      const { data } = await api.get("/public/branding");
      const next = {
        organization_name: data.organization_name || "ISCIC Trust",
        logo_url: data.logo_url || "/brand/iscic-logo.jpg",
        favicon_url: data.favicon_url || data.logo_url || "/brand/iscic-logo.jpg",
      };
      setBrand(next);
      applyFavicon(next.favicon_url);
      if (data.organization_name) document.title = `${data.organization_name} · ICOS`;
    } catch (e) { console.warn("branding fetch failed", e); }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <BrandingContext.Provider value={{ ...brand, refresh }}>{children}</BrandingContext.Provider>
  );
}

export const useBranding = () => useContext(BrandingContext);
